import {ProductInputData} from '../redux/product/productTypes';
import { ClampexType } from '../types/types';

/**
 * This function saves the selection of the product
 * @param productData 
 */
export default function SaveSelection(clampexType: ClampexType, productData: ProductInputData) {

    const currentdate = new Date(); 
    const datetime = currentdate.getDate() + "."
                + (currentdate.getMonth()+1)  + "." 
                + currentdate.getFullYear() + " @ "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();

    const storageKey = "com.ktr.otools.layoutpara.paraset.clampex." + clampexType + "." +  Date.now();
    //save to local storage (exclude errorfields and include date and storageKey)
    window.localStorage.setItem(storageKey, JSON.stringify({...productData, date:datetime, storageKey: storageKey,errorFields: undefined} as ProductInputData));
}